export default __webpack_public_path__ + "static/media/MapSidebar.91fb0799.png";